import { createContext, useContext } from 'react';
import { useFindCurrency } from 'hooks/useFindCurrency';
// Del fichero concreto y no del barril, por lo mismo que en `useFindCurrency`:
// el barril arrastra `payment-settings.filters` -> `common.columns`.
import { CURRENCY_TYPE_ENUM } from 'modules/sales/settings/payment-settings/constants/currency-type.enum';

type CurrencyContextValue = {
  primary?: CURRENCY_TYPE_ENUM;
  isLoading: boolean;
  error?: any;
};

// default value of the context
const defaultValue: CurrencyContextValue = {
  isLoading: true,
};

// create context
// @ts-ignore
const CurrencyContext = createContext<CurrencyContextValue>(defaultValue);

// Proptypes of Provider component
type CurrencyContextProps = {
  children: any;
};

/**
 * Provider component
 * */
const CurrencyProvider = (props: CurrencyContextProps) => {
  const { data, isLoading, error } = useFindCurrency();
  return <CurrencyContext.Provider value={{ primary: data?.primary || CURRENCY_TYPE_ENUM.USD, isLoading, error }} {...props} />;
};

// Default hooks to retrieve context data
const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (context === undefined) {
    throw new Error('You must be inside a CurrencyProvider'); // also, you can throw an error if it is you need the context
  }
  return context;
};

export { CurrencyProvider, useCurrency };
